import { useQuery } from '@tanstack/react-query';

import { type IAppName, getJobs } from '~/services/AwsJobsService';

export function useGetJobs(selectedTab: IAppName) {
  return useQuery({
    queryKey: ['aws-jobs', selectedTab],
    queryFn: () => getJobs(selectedTab),
    select: (data) => data?.result ?? [],
  });
}
